import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=79ff8830&scoped=true&"
import script from "./ServiceTypes.vue?vue&type=script&lang=js&"
export * from "./ServiceTypes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypes.vue?vue&type=style&index=0&id=79ff8830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff8830",
  null
  
)

export default component.exports